import "core-js/stable";
import "regenerator-runtime/runtime";
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

const occasionRoot = document.getElementById('reviews')
const { dealerid } = occasionRoot.dataset

ReactDOM.render(<App dealerid={dealerid} />, occasionRoot);